export const appVersion = "1.0.0-web"
